import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Avatar,
  Typography,
  Dialog,
  DialogBody,
  Button,
  Input,
  Alert,
} from "@material-tailwind/react";
import { useGlobalData } from "./GlobalContext";
import { useEffect, useRef, useState } from "react";
import EasyCropper from "react-easy-crop";
import React from "react";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import useFetch, { useHttp } from "@/hooks/useFetch";
import store from "@/utils/store";
import { compressImage, getWebsite, obs, UUID } from "@/utils";
import Iconify from "../common/Iconify";
import axios from "axios";
import { ForgotPasswordDialog } from "../common/ForgotPasswordDialog";

async function _getCroppedImg(url: string, pixelCrop: any, rotation = 0) {
  const image: any = await new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.src = url;
  });
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx || !image) {
    return null;
  }

  const imageSize =
    2 * ((Math.max(image.width, image.height) / 2) * Math.sqrt(2));
  canvas.width = imageSize;
  canvas.height = imageSize;

  if (rotation) {
    ctx.translate(imageSize / 2, imageSize / 2);
    ctx.rotate((rotation * Math.PI) / 180);
    ctx.translate(-imageSize / 2, -imageSize / 2);
  }

  ctx.drawImage(
    image,
    imageSize / 2 - image.width / 2,
    imageSize / 2 - image.height / 2
  );
  const data = ctx.getImageData(0, 0, imageSize, imageSize);
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  ctx.putImageData(
    data,
    Math.round(0 - imageSize / 2 + image.width * 0.5 - pixelCrop.x),
    Math.round(0 - imageSize / 2 + image.height * 0.5 - pixelCrop.y)
  );
  return new Promise((resolve) => {
    const imgUrl = canvas.toDataURL();
    resolve(imgUrl);
    // canvas.toBlob((blob) => {
    //   resolve(blob);
    // });
  });
} // 裁剪组件
interface CropperProps {
  file?: File;
  onOk: (file: File) => void;
  onCancel: () => void;
}

const Cropper: React.FC<CropperProps> = ({ file, onOk, onCancel }) => {
  const [crop, setCrop] = useState({
    x: 0,
    y: 0,
  });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(undefined);
  const [showModal, setShowModal] = useState(false);
  const url = React.useMemo(() => {
    return file ? URL.createObjectURL(file) : "";
  }, [file]);
  return (
    <Dialog size="xs" open={!!file} handler={() => onCancel()}>
      <DialogBody>
        <div>
          <div
            style={{
              width: "100%",
              height: 280,
              position: "relative",
            }}
          >
            <EasyCropper
              style={{
                containerStyle: {
                  width: "100%",
                  height: 280,
                },
              }}
              aspect={4 / 4}
              image={url}
              crop={crop}
              zoom={zoom}
              rotation={rotation}
              onRotationChange={setRotation}
              onCropComplete={(_, croppedAreaPixels) => {
                setCroppedAreaPixels(croppedAreaPixels);
              }}
              onCropChange={setCrop}
              onZoomChange={setZoom}
            />
          </div>

          <div className="flex shrink-0 flex-wrap items-center pt-4 justify-center">
            <Button
              className="w-[100px]"
              onClick={async () => {
                const imgUrl: any = await _getCroppedImg(
                  url || "",
                  croppedAreaPixels,
                  rotation
                );
                const blob = await compressImage(imgUrl, 200, 200);
                if (blob && file) {
                  const newFile = new File([blob], file.name || "image", {
                    type: file.type || "image/*",
                  });
                  onOk(newFile);
                }
              }}
            >
              确定
            </Button>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
};

export function ProfileMenu() {
  const {
    userInfo,
    confrim,
    logout,
    setUserInfo,
    getUserInfo,
    alert,
    showGlobalCodeModal,
    setShowGlobalCodeModal,
  } = useGlobalData();
  const [showModal, setShowModal] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | undefined>();
  const [nickName, setNickName] = useState(userInfo?.nickName);
  const [code, setCode] = useState("");
  const [showCodeModal, setShowCodeModal] = useState(false);
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);

  useEffect(() => {
    if (showModal) {
      setNickName(userInfo?.nickName);
    }
  }, [showModal]);

  // 全局控制会员兑换弹框
  useEffect(() => {
    if (showGlobalCodeModal) {
      setShowCodeModal(true);
    }
  }, [showGlobalCodeModal]);

  // 关闭弹框时同步关闭全局状态
  const handleCloseCodeModal = () => {
    setShowCodeModal(false);
    setShowGlobalCodeModal && setShowGlobalCodeModal(false);
  };

  const { Http } = useHttp();
  const signOut = () => {
    confrim({
      title: <div className="w-full text-center">提示</div>,
      message: <div className="font-bold">确认退出登录吗？</div>,
      onConfirm: () => {
        // Perform sign out logic here
        logout();
      },
    });
  };
  const handleBtnClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const updateUserInfo = async (key: keyof UserInfo, value: string) => {
    await Http.post("/app/user/info/updatePerson", {
      [key]: value,
    });
    const newUserInfo = {
      ...userInfo!,
      [key]: value,
    };
    setUserInfo!(newUserInfo);
    store.setItem("userInfo", newUserInfo);
  };
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFile(file);
    }
  };
  const vip = () => {
    if (!userInfo?.permissions) {
      return "永久VIP";
    }
    if (userInfo?.permissions?.includes(`${getWebsite()}:word`)) {
      return "永久VIP";
    }
    if (userInfo?.member?.isValid) {
      return `会员有效期至：${userInfo.member?.endDate.slice(0, 11)}`;
    }
    return "未开通会员";
  };
  const isYongjiu = () => {
    return vip().includes("永久");
  };
  const Icon = () => {
    return (
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 48 48"
      >
        <defs>
          <mask id="ipSVipOne0">
            <g
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="4"
            >
              <path
                fill="#fff"
                stroke="#fff"
                d="m4.503 16.366l8.013-8.694A2.13 2.13 0 0 1 14.082 7h19.836a2.13 2.13 0 0 1 1.566.672l8.013 8.694a1.85 1.85 0 0 1-.035 2.572L24.75 40.15a1 1 0 0 1-1.5 0L4.538 18.938a1.85 1.85 0 0 1-.035-2.572"
              />
              <path stroke="#000" d="m16 20l8 9l8-9" />
            </g>
          </mask>
        </defs>
        <path fill="#eaaa40" d="M0 0h48v48H0z" mask="url(#ipSVipOne0)" />
      </svg>
    );
  };
  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".jpg, .jpeg, .png"
        style={{ display: "none" }}
        // 在选择文件后触发的事件处理函数
        onChange={handleFileSelect}
        // 设置多选
        multiple={false}
      />

      <Dialog size="xs" open={!!showModal} handler={() => setShowModal(false)}>
        <DialogBody className="flex flex-col justify-center items-center py-7">
          <Cropper
            file={file}
            onOk={async (data) => {
              setFile(undefined);
              const formData = new FormData();
              formData.append("file", data);
              formData.append("key", `user/web/${UUID()}_${file?.name}`);

              const res: any = await Http.post("app/base/comm/upload");
              formData.append("token", res.token);

              const image: any = await axios.post(res.uploadUrl, formData);

              const avatarUrl = res.publicDomain + "/" + image.data.key;

              updateUserInfo("avatarUrl", avatarUrl);
            }}
            onCancel={() => setFile(undefined)}
          />
          <div
            onClick={() => handleBtnClick()}
            className="w-[100px] mb-5 cursor-pointer h-[100px] group rounded-[100%] overflow-hidden relative"
          >
            <img className=" w-full h-full" src={userInfo?.avatarUrl} alt="" />
            <div className="w-full opacity-0 transition-all group-hover:opacity-100 flex items-center justify-center h-full bg-black/20 top-0 left-0 absolute z-2">
              <PencilSquareIcon className="w-5 h-5 text-white" />
            </div>
          </div>
          <div className="w-[200px]">
            <Input
              maxLength={10}
              onChange={(e) => {
                setNickName(e.target.value);
              }}
              value={nickName}
              variant="standard"
              placeholder="请输入昵称"
              crossOrigin={undefined}
            />
          </div>

          <Button
            size="md"
            className="w-[200px] mt-5"
            onClick={() => {
              if (nickName) {
                updateUserInfo("nickName", nickName);
                setShowModal(false);
              }
            }}
          >
            保存
          </Button>
        </DialogBody>
      </Dialog>

      <Dialog size="xs" open={!!showCodeModal} handler={handleCloseCodeModal}>
        <DialogBody className="flex flex-col justify-center items-center py-7">
          <div className="w-[200px]">
            <div className="text-xl font-bold text-center flex items-center justify-center flex-col ">
              <div className="w-10">{Icon()}</div>
              <span className="mt-3">我的会员</span>
            </div>
            <div className="text-sm font-bold mb-4 text-center mt-2">
              {vip()}
            </div>

            {!isYongjiu() && (
              <Input
                maxLength={10}
                onChange={(e) => {
                  setCode(e.target.value);
                }}
                value={code}
                variant="standard"
                label="输入兑换码"
                crossOrigin={undefined}
              />
            )}
          </div>

          {!isYongjiu() && (
            <Button
              size="md"
              className="w-[200px] mt-5"
              onClick={async () => {
                if (code) {
                  const message: string = await Http.post(
                    "/app/user/info/registerCode",
                    {
                      code,
                    }
                  );
                  if (message) {
                    setCode("");
                    return alert({
                      color: "red",
                      message,
                    });
                  }

                  getUserInfo();
                  handleCloseCodeModal();
                  setCode("");
                  alert({
                    color: "green",
                    message: "兑换成功",
                  });
                }
              }}
            >
              确定
            </Button>
          )}
        </DialogBody>
      </Dialog>
      <Menu>
        <MenuHandler>
          <Avatar
            variant="circular"
            alt="tania andrew"
            className="cursor-pointer"
            src={obs(userInfo?.avatarUrl)}
          />
        </MenuHandler>
        <MenuList>
          <MenuItem
            onClick={() => setShowCodeModal(true)}
            className="flex items-center gap-2"
          >
            <div className="w-4">{Icon()}</div>
            <Typography variant="small" className="font-medium">
              <div>我的会员</div>
            </Typography>
          </MenuItem>
          <MenuItem
            onClick={() => setShowModal(true)}
            className="flex items-center gap-2"
          >
            <svg
              width="16"
              height="16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.48999 1.17C9.10999 -0.39 6.88999 -0.39 6.50999 1.17C6.45326 1.40442 6.34198 1.62213 6.18522 1.80541C6.02845 1.9887 5.83063 2.13238 5.60784 2.22477C5.38505 2.31716 5.1436 2.35564 4.90313 2.33709C4.66266 2.31854 4.42997 2.24347 4.22399 2.118C2.85199 1.282 1.28199 2.852 2.11799 4.224C2.65799 5.11 2.17899 6.266 1.17099 6.511C-0.390006 6.89 -0.390006 9.111 1.17099 9.489C1.40547 9.54581 1.62322 9.65719 1.80651 9.81407C1.98979 9.97096 2.13343 10.1689 2.22573 10.3918C2.31803 10.6147 2.35639 10.8563 2.33766 11.0968C2.31894 11.3373 2.24367 11.5701 2.11799 11.776C1.28199 13.148 2.85199 14.718 4.22399 13.882C4.42993 13.7563 4.66265 13.6811 4.90318 13.6623C5.14371 13.6436 5.38527 13.682 5.60817 13.7743C5.83108 13.8666 6.02904 14.0102 6.18592 14.1935C6.34281 14.3768 6.45419 14.5945 6.51099 14.829C6.88999 16.39 9.11099 16.39 9.48899 14.829C9.54599 14.5946 9.65748 14.377 9.8144 14.1939C9.97132 14.0107 10.1692 13.8672 10.3921 13.7749C10.6149 13.6826 10.8564 13.6442 11.0969 13.6628C11.3373 13.6815 11.57 13.7565 11.776 13.882C13.148 14.718 14.718 13.148 13.882 11.776C13.7565 11.57 13.6815 11.3373 13.6628 11.0969C13.6442 10.8564 13.6826 10.6149 13.7749 10.3921C13.8672 10.1692 14.0107 9.97133 14.1939 9.81441C14.377 9.65749 14.5946 9.546 14.829 9.489C16.39 9.11 16.39 6.889 14.829 6.511C14.5945 6.45419 14.3768 6.34281 14.1935 6.18593C14.0102 6.02904 13.8666 5.83109 13.7743 5.60818C13.682 5.38527 13.6436 5.14372 13.6623 4.90318C13.681 4.66265 13.7563 4.42994 13.882 4.224C14.718 2.852 13.148 1.282 11.776 2.118C11.5701 2.24368 11.3373 2.31895 11.0968 2.33767C10.8563 2.35639 10.6147 2.31804 10.3918 2.22574C10.1689 2.13344 9.97095 1.9898 9.81407 1.80651C9.65718 1.62323 9.5458 1.40548 9.48899 1.171L9.48999 1.17ZM7.99999 11C8.79564 11 9.55871 10.6839 10.1213 10.1213C10.6839 9.55871 11 8.79565 11 8C11 7.20435 10.6839 6.44129 10.1213 5.87868C9.55871 5.31607 8.79564 5 7.99999 5C7.20434 5 6.44128 5.31607 5.87867 5.87868C5.31606 6.44129 4.99999 7.20435 4.99999 8C4.99999 8.79565 5.31606 9.55871 5.87867 10.1213C6.44128 10.6839 7.20434 11 7.99999 11Z"
                fill="#90A4AE"
              />
            </svg>

            <Typography variant="small" className="font-medium">
              用户信息
            </Typography>
          </MenuItem>
          <MenuItem
            onClick={() => setForgotPasswordOpen(true)}
            className="flex items-center gap-2"
          >
            <svg
              width="16"
              height="16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1C6.34315 1 5 2.34315 5 4V6C4.44772 6 4 6.44772 4 7V13C4 13.5523 4.44772 14 5 14H11C11.5523 14 12 13.5523 12 13V7C12 6.44772 11.5523 6 11 6V4C11 2.34315 9.65685 1 8 1ZM6 4C6 3.44772 6.44772 3 7 3H9C9.55228 3 10 3.44772 10 4V6H6V4ZM6 8C6 7.44772 6.44772 7 7 7H9C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9H7C6.44772 9 6 8.55228 6 8Z"
                fill="#90A4AE"
              />
            </svg>
            <Typography variant="small" className="font-medium">
              修改密码
            </Typography>
          </MenuItem>

          {/* <hr className="my-2 border-blue-gray-50" /> */}
          <MenuItem
            onClick={() => signOut()}
            className="flex items-center gap-2 "
          >
            <svg
              width="16"
              height="14"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 0C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V13C0 13.2652 0.105357 13.5196 0.292893 13.7071C0.48043 13.8946 0.734784 14 1 14C1.26522 14 1.51957 13.8946 1.70711 13.7071C1.89464 13.5196 2 13.2652 2 13V1C2 0.734784 1.89464 0.48043 1.70711 0.292893C1.51957 0.105357 1.26522 0 1 0ZM11.293 9.293C11.1108 9.4816 11.01 9.7342 11.0123 9.9964C11.0146 10.2586 11.1198 10.5094 11.3052 10.6948C11.4906 10.8802 11.7414 10.9854 12.0036 10.9877C12.2658 10.99 12.5184 10.8892 12.707 10.707L15.707 7.707C15.8945 7.51947 15.9998 7.26516 15.9998 7C15.9998 6.73484 15.8945 6.48053 15.707 6.293L12.707 3.293C12.6148 3.19749 12.5044 3.12131 12.3824 3.0689C12.2604 3.01649 12.1292 2.9889 11.9964 2.98775C11.8636 2.9866 11.7319 3.0119 11.609 3.06218C11.4861 3.11246 11.3745 3.18671 11.2806 3.2806C11.1867 3.3745 11.1125 3.48615 11.0622 3.60905C11.0119 3.73194 10.9866 3.86362 10.9877 3.9964C10.9889 4.12918 11.0165 4.2604 11.0689 4.3824C11.1213 4.50441 11.1975 4.61475 11.293 4.707L12.586 6H5C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7C4 7.26522 4.10536 7.51957 4.29289 7.70711C4.48043 7.89464 4.73478 8 5 8H12.586L11.293 9.293Z"
                fill="#90A4AE"
              />
            </svg>
            <Typography variant="small" className="font-medium">
              退出登录
            </Typography>
          </MenuItem>
        </MenuList>
      </Menu>

      {/* 忘记密码弹框 */}
      <ForgotPasswordDialog
        open={forgotPasswordOpen}
        onClose={() => setForgotPasswordOpen(false)}
      />
    </>
  );
}

export const ReplyContent = () => {
  const { Http } = useHttp();
  const { userInfo } = useGlobalData();
  const Reply = useFetch({
    url: "/app/user/feedback/getReply",
    method: "get",
    onSuccess: (data) => {
      if (data) {
        setTimeout(() => {
          setOpen(true);
        }, 300);
      }
    },
  });
  const [open, setOpen] = React.useState(false);
  const global = useGlobalData();
  useEffect(() => {
    if (userInfo) {
      Reply.fetchData();
    }
  }, [userInfo]);
  return (
    <div>
      <Alert
        animate={{
          mount: { x: 0 },
          unmount: { x: 400 },
        }}
        open={open}
        icon={
          <img
            className="w-10 h-10 rounded-full"
            src={global.userInfo?.avatarUrl}
          />
        }
        className="max-w-[80vw] xl:max-w-screen-md inline-flex w-auto fixed top-20 mr-3 right-0"
        onClose={() => {
          setOpen(false);
          Http.post("/app/user/feedback/removeReply");
        }}
      >
        <Typography color="white" className="font-normal">
          {Reply.data?.content || "-"}
        </Typography>

        <Typography variant="h5" color="white" className="mt-2 ">
          {Reply.data?.replyContent || "-"}
        </Typography>
      </Alert>
    </div>
  );
};
